//
// Purpose: SAMB - top uom buttons
// Author: Ronny Van Elewyck
// Version: 1.0
// Creation Date: 17.07.2020
// Modification Date: 27.08.2020
//

// installed components
import React from "react";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

// created components
import ExportCSV from "./exportCSV";

// config files
import {
  //refreshClass5,
  classTopButtons5,
  downloadClass5,
  newClass5,
} from "../../config.json";

const TopUOMButton = ({
  listArray,
  handleRefresh,
  fileName,
  screenFilter,
  handleNew,
  isAdmin,
}) => {
  const [uom, setValue1] = React.useState(screenFilter);

  function renderTooltip(title) {
    return <Tooltip id="button-tooltip">{title}</Tooltip>;
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      handleRefresh(uom);
    }
  }

  return (
    <div className={classTopButtons5}>
      {isAdmin && (
        <div>
          <OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip("nieuw")}
          >
            <div>
              <button
                type="button"
                className={newClass5}
                onClick={() => handleNew()}
              ></button>
            </div>
          </OverlayTrigger>
        </div>
      )}

      <input
        type="text"
        className="form-control mt-1"
        placeholder="Filter..."
        value={uom}
        onChange={(e) => setValue1(e.currentTarget.value)}
        onKeyDown={handleKeyDown}
        size={200}
      />
      <ExportCSV
        csvData={listArray}
        fileName={fileName}
        className={downloadClass5}
      />
    </div>
  );
};

export default TopUOMButton;
